export var SeriesType;
(function (SeriesType) {
    SeriesType["Bubble"] = "bubble";
})(SeriesType || (SeriesType = {}));
